var _excluded = ["logo", "socials", "categories", "partners", "footer"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { Fragment } from "react";
import styled from "styled-components";
import useBreakpoint from "../../../../hooks/useBreakpoint";
import breakpoint from "../../../../utils/breakpoint";
import space from "../../../../utils/space";
import GridOrg from "../../../organisms/GridOrg";
import PushOrg from "../../../organisms/PushOrg";
var Header = styled.div.withConfig({
  componentId: "sc-mvnbbs-0"
})(["display:grid;grid-gap:", ";align-items:center;margin-bottom:", ";", "{grid-gap:", ";margin-bottom:", ";}", "{grid-gap:", ";grid-template-columns:auto auto;justify-content:space-between;margin-bottom:", ";}> :first-child{align-self:start;}"], space(5), space(5), breakpoint("medium", "large"), space(6), space(6), breakpoint("large"), space(9), space(12));
function PageFooterOrg(_ref) {
  var logo = _ref.logo,
    socials = _ref.socials,
    categories = _ref.categories,
    partners = _ref.partners,
    footer = _ref.footer,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var isSmallOnly = useBreakpoint("small", "medium");
  var isMediumOnly = useBreakpoint("medium", "large");
  var shouldCategoryBeVisible = function shouldCategoryBeVisible(category) {
    return isSmallOnly && !category.isHiddenOnSmall || isMediumOnly && !category.isHiddenOnMedium || !isSmallOnly && !isMediumOnly;
  };
  return /*#__PURE__*/React.createElement("div", restProps, /*#__PURE__*/React.createElement(Header, null, logo, socials), /*#__PURE__*/React.createElement(GridOrg, {
    columns: {
      small: 1,
      medium: 3,
      large: 5
    },
    gutterSpace: {
      small: 5,
      medium: 10,
      large: 10
    }
  }, categories.map(function (category, index) {
    return shouldCategoryBeVisible(category) &&
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    React.createElement(Fragment, {
      key: "category-".concat(index)
    }, category.content);
  }), !isSmallOnly && partners), footer ? /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: {
      small: 5,
      medium: 5,
      large: 10
    }
  }, footer) : null);
}
export default PageFooterOrg;